export default __webpack_public_path__ + "static/media/p2p.a97198d4.mp4";